import React from "react";
import styles from "./topDonorDonations.module.scss";
import { DONATION_TYPES_TOP } from "../../../../entities/profile_donation_types";
import { MainDonationTypes } from "../../../profileComponents/profileDonationTypes";
import { TUserData } from "../../../../stores/EventStore";
import { observer } from "mobx-react";

type TTopDonorDonations = {
  user: TUserData;
};

const TopDonorDonations: React.FC<TTopDonorDonations> = observer(({ user }) => {
  if (!user) return null;
  return (
    <div className={styles.TopDonorDonations}>
      <div className={styles.TopDonorDonations_Count}>
        донации <span>{user.donation_agg.count}</span>
      </div>
      <div className={styles.TopDonorDonations_Aggs}>
        {Object.keys(DONATION_TYPES_TOP).map((key) => {
          if (user?.donation_agg)
            if (user?.donation_agg[key])
              return (
                <div key={key}>
                  <MainDonationTypes
                    tooltip={DONATION_TYPES_TOP[key]?.title}
                    icon={DONATION_TYPES_TOP[key]?.icon}
                    count={user?.donation_agg[key]}
                    iconStyle={{ width: "14px", height: "14px" }}
                  />
                </div>
              );
        })}
      </div>
    </div>
  );
});

export default TopDonorDonations;
